import script from "./DiscoveryModify.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscoveryModify.vue?vue&type=script&setup=true&lang=js"

import "./DiscoveryModify.vue?vue&type=style&index=0&id=6616de02&lang=css"

const __exports__ = script;

export default __exports__